import * as React from "react";
import { styled } from "@mui/system";
import MUIFormHelperText from "@mui/material/FormHelperText";
import Typography from "@mui/material/Typography";
import Box from "../Box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons/faMinusCircle";
import { FormHelperTextProps as FormHelperTextPropsMUI } from "@mui/material/FormHelperText";
export type FormHelperTextProps = {
  children?: React.ReactNode;
  component?: React.ElementType;
} & FormHelperTextPropsMUI;
export const FormHelperText: (props: FormHelperTextProps) => JSX.Element =
  styled(
    React.forwardRef<any, FormHelperTextProps>((props, ref) => {
      const helperConst = (
        <Box>
          <FontAwesomeIcon
            icon={faMinusCircle}
            style={{ width: "12px", height: "12px" }}
          ></FontAwesomeIcon>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontWeight: "400",
              lineHeight: "16px",
              fontSize: "12px"
            }}
            color="error"
            component="span"
          >
            {" " + props.children}
          </Typography>
        </Box>
      );
      return (
        <MUIFormHelperText
          ref={ref}
          {...props}
          component={props?.error && props?.children ? "div" : "p"}
        >
          {props?.error && props?.children ? helperConst : props?.children}
        </MUIFormHelperText>
      );
    }),
    {
      name: "FormHelperText",
      slot: "Root",
      overridesResolver: (props, styles) => []
    }
  )(({ theme }) => ({}));
